<template>
  <div class="mt-5" v-if="show">
    <div class="uppercase text-xs">{{$t('Settings')}}</div>
    <div class="mt-3 space-y-3">
      <toggle-button class="flex items-center cursor-pointer" v-model="allowComments">
        <span class="ml-2.5 text-sm text-gray-500">
          {{$t('Allow comments')}}
        </span>
      </toggle-button>

      <toggle-button class="flex items-center cursor-pointer" v-model="requestApproval">
        <span class="ml-2.5 text-sm text-gray-500">
          {{$t('Request approval')}}
        </span>
      </toggle-button>
      <!--
      <toggle-button class="flex items-center cursor-pointer">
        <span class="ml-2.5 text-sm text-gray-500">
          Reminder
        </span>
      </toggle-button>
      -->
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import useBcDocumentStore from '@/frontapp/store/bcDocument'
import { DocumentApi } from '../../test-api/index.ts'
import openApproval from '../../mixins/actions/OpenApproval'

const documentApi = new DocumentApi({}, '/api/v2')

export default {
  data() {
    return {};
  },
  computed: {
    show () {
      return this.bcDocumentStore.document.can_edit && this.bcDocumentStore.edit
    },
    requestApproval: {
      get () {
        return this.bcDocumentStore.document?.approval !== null
      },
      set (val) {
        if (val !== !this.bcDocumentStore.document.disable_approval) {
          this.bcDocumentStore.addToUpdateQueue(() => new Promise((resolve/*, reject*/) => {
            documentApi.documentUpdateSettings(
              this.bcDocumentStore.document.id,
              this.bcDocumentStore.document.bc_document_rev_id,
              { disable_approval: !val }
            ).then((data) => {
              this.bcDocumentStore.document.approval = data.data.approval
              this.bcDocumentStore.document.disable_approval = data.data.disable_approval
              
              if (data.data.bc_document_rev_id !== this.bcDocumentStore.document.bc_document_rev_id) {
                this.bcDocumentStore.willChangeRevision = true
                this.$router.replace({ 
                  name: 'BCDocumentDetailRev',
                  params: { revId: data.data.bc_document_rev_id } 
                }).then(() => {
                  if (val) {
                    this.openForm(data.data.approval, data.data.bc_document_rev_id)
                  }
                  
                  resolve()
                })
              } else {
                
                if (val) {
                  this.openForm(data.data.approval, data.data.bc_document_rev_id)
                }
                resolve()
              }
            })
          }))
        } else if (val) {
          this.openForm(this.bcDocumentStore.document.approval, this.bcDocumentStore.document.bc_document_rev_id)
        }
      }
    },
    allowComments: {
      get () {
        return this.bcDocumentStore.document?.allow_comments
      },
      set (val) {
        this.bcDocumentStore.addToUpdateQueue(() => new Promise((resolve/*, reject*/) => {
          documentApi.documentUpdateSettings(
            this.bcDocumentStore.document.id,
            this.bcDocumentStore.document.bc_document_rev_id,
            { allow_comments: val }
          ).then((data) => {
            if (data.data.bc_document_rev_id !== this.bcDocumentStore.document.bc_document_rev_id) {
              this.bcDocumentStore.willChangeRevision = true
              this.$router.replace({ 
                name: 'BCDocumentDetailRev',
                params: { revId: data.data.bc_document_rev_id } 
              }).then(() => {
                resolve()
              })
            } else {
              resolve()
            }
          })
        }))
        this.bcDocumentStore.document.allow_comments = val
      }
    },
    ...mapStores(useBcDocumentStore),
  },
  methods: {
    openForm(approval, documentRevId) {
      openApproval(this.$store, this.$formValues, approval, this.bcDocumentStore.document.id, documentRevId || this.bcDocumentStore.document.bc_document_rev_id, true)
    }
  }
};
</script>

<style lang="scss" scoped></style>
